module.exports = __webpack_public_path__ + "img/blog-footer.04e86f7c.webp";